import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { IBookingObj } from '@types';
import { Icons } from '@assets';

interface IProps {
    record: IBookingObj | undefined;
    status: number;
    setStatus: any;
}

const selectOptions = [
    undefined,
    { key: 'cancel', value: 'cancel', label: 'Отклонить' },
    { key: 'approve', value: 'approve', label: 'Подтвердить' },
    undefined,
    undefined,
    { key: 'timeout', value: 'timeout', label: ' Новая заявка' },
];

const NewStatusSelector = (props: IProps) => {
    const { status, setStatus } = props;
    const [switchIsOpen, setSwitchIsOpen] = useState(false);

    const dropdownRef = useRef<HTMLDivElement>(null);

    const swithHandler = (key: number) => {
        if (key !== status) {
            setStatus(key);
        }
        setSwitchIsOpen(false);
    };

    const toggleDropdown = () => {
        setSwitchIsOpen(!switchIsOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setSwitchIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    return (
        <NoiseNameContainer
            key={'container'}
            id={'container'}
            onClick={event => event.stopPropagation()}
        >
            <TitleLabel
                onClick={() => {
                    setSwitchIsOpen(!switchIsOpen);
                }}
            >
                {selectOptions[status]?.label || ''}
            </TitleLabel>
            <NoiseSelectorBtn onClick={toggleDropdown}>
                {switchIsOpen ? (
                    <IconWrapper>
                        <img src={Icons.IconArrowUp} alt="Proga.pro arrow" />
                    </IconWrapper>
                ) : (
                    <IconWrapper>
                        <img
                            src={Icons.IconArrowDown}
                            alt="Proga.pro arrowdown"
                        />
                    </IconWrapper>
                )}
            </NoiseSelectorBtn>
            {switchIsOpen && (
                <SelectorDropdown ref={dropdownRef}>
                    {selectOptions?.map((item, ind) => {
                        return ind === status || !item ? null : (
                            <>
                                <Br />
                                <TitleLabel
                                    decl={item?.key === 'discard'}
                                    key={ind}
                                    onClick={() => swithHandler(ind)}
                                >
                                    <span>{item?.label}</span>
                                </TitleLabel>
                            </>
                        );
                    })}
                </SelectorDropdown>
            )}
        </NoiseNameContainer>
    );
};

export default NewStatusSelector;

const Br = styled.div`
    width: 98px;
    height: 1px;
    border: 1px solid #eeefef;
`;
const TitleLabel = styled.div<{
    decl?: boolean;
}>`
    /* Frame 427322058 */

    /* box-sizing: border-box; */

    width: 200px;
    height: 38px;
    /* #8F8F8F 30% */
    /* Подтвержден */

    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    /* identical to box height, or 200% */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;

    /* Текст/#333333 текст|кнопки */
    color: #333333;

    & span {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        /* identical to box height, or 200% */
        color: ${({ decl }) => (decl ? '#DD1A6A' : '#333333')};
    }
`;

const SelectorDropdown = styled.div`
    width: 200px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    justify-content: center;
    z-index: 8;
    padding-top: 10px;
    align-items: center;
    top: 30px;
    left: -1px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid rgba(143, 143, 143, 0.3);
    border-top: none;
    border-radius: 0 0 5px 5px;

    /* border-radius: 8px;
  box-shadow: 0px 0px 8px 0px rgb(158 158 158 / 40%); */

    ::-webkit-scrollbar {
        width: 14px;
        /* border-radius: 8px; */
        background-color: inherit;
    }

    ::-webkit-scrollbar-thumb {
        height: 140px;
        background-color: #e7e7e7;
        /* border-radius: 8px;
    border: 5px solid #fff; */
    }
`;

const NoiseSelectorBtn = styled.div`
    position: absolute;
    right: 6px;
    top: 4px;
    & svg path {
        fill: #a7a7a7;
    }
`;

const NoiseNameContainer = styled.div`
    /* Frame 195 */
    margin-left: 20px;
    width: 200px;
    height: 38px;
    justify-content: space-between;
    /* Текст/#FFFFFF текст|иконки|кнопки */
    background: #ffffff;
    box-shadow: 0px 2px 15.2px rgba(0, 0, 0, 0.11);
    border-radius: 5px;
    position: relative;
    display: flex;
    font-weight: 600;
    font-size: 13px;
    line-height: 26px;
    letter-spacing: 0.02em;
    color: #1f1e24;
    /* text-transform: capitalize; */
    cursor: pointer;
    border: 1px solid #d6dce9;

    z-index: 1005;
`;
const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
`;
